const config = {
    API_URL: process.env.REACT_APP_API_URL,
    // REACT_APP_API_URL,
    // REACT_APP_API_URL_LOCAL,
    // REACT_APP_API_URL,
    // REACT_APP_API_URL_LOCAL,
    // process.env.REACT_APP_API_URL,
    API_STAGING_URL: process.env.REACT_APP_API_STAGING_URL,
    API_STAGING_URL_SIMPLE: process.env.REACT_APP_API_STAGING_URL_SIMPLE,

    API_URL_LOCAL: process.env.REACT_APP_API_LOCAL,
    DEVICE_CONTROL_API: process.env.REACT_APP_API_DEVICE_CONTROL_API,
};

export default config;
